import { Spinner } from 'react-bootstrap';

export default function Loader({ label = 'Loading...', className = '', size }) {
  return (
    <div className={`text-center py-4 text-muted ${className}`}>
      <Spinner animation="border" size={size} style={{ color: 'var(--clinic-primary)' }} />
      {label ? <div className="mt-2 small">{label}</div> : null}
    </div>
  );
}
